module.exports = __webpack_public_path__ + "img/multi_user.98429fae.svg";